import { operations as organizationOperations } from '@saucelabs/sl-module-organization';

/** Set a country to current organization.
 * This operation fails if the country is already set. In this case, fail silently.
 * @param {string} country
 * */
export const setOrganizationCountry = (country) => (dispatch) => (
  dispatch(organizationOperations.patchSettings({ country })).catch(
    (err) => {
      if (err?.response?.status < 500) return; // disregard failed update
      throw err;
    },
  )
);
